import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const RELATED_RESOURCES_COMPONENT_NAME = 'related_resources';

export type RelatedResourceExposedBiData = {
  requestId: string | undefined;
  itemType: 'article' | 'video';
  itemId: string;
  itemName: string;
  position: number;
  mediaUrls?: string;
};

/**
 * 4:1530 - one event per resource card shown in the related-resources panel.
 */
export const logRelatedResourceExposed: BiEventLogger<RelatedResourceExposedBiData> = async (
  state,
  { requestId, itemType, itemId, itemName, position, mediaUrls },
) => {
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  await biLogger.chatbotRelatedResourceExposed(state, {
    session_id: sessionId,
    chatbot_view: contextBi?.chatbot_view,
    request_id: requestId,
    component_name: RELATED_RESOURCES_COMPONENT_NAME,
    item_type: itemType,
    item_id: itemId,
    item_name: itemName,
    position,
    media_urls: mediaUrls,
  });
};
